import { AfterViewInit, Component, ElementRef, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { TRUSTPILOT_WIDGET } from '../../../bdo/enums/trustpilotWidget';
import { TrustpilotWidgetLoaderService } from '../../../bdo/services/trustpilot-widget-loader.service';

@Component({
  selector: 'bdo-trustpilot-widget',
  templateUrl: './trustpilot-widget.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TrustpilotWidgetComponent implements AfterViewInit {
  public readonly businessunitId = input<string>(TRUSTPILOT_WIDGET.businessUnitId);
  public readonly templateId = input<string>(TRUSTPILOT_WIDGET.templateId);
  public readonly theme = input<'light' | 'dark'>('light');
  public readonly height = input<string>('150px');
  public readonly width = input<string>('100%');
  public readonly stars = input<string>('4,5');

  public readonly locale = 'de-DE';
  public readonly reviewLanguages = 'de';
  public readonly profileUrl = 'https://de.trustpilot.com/review/rheinenergie.com';

  public readonly trustbox = viewChild.required<ElementRef<HTMLDivElement>>('trustbox');

  constructor(private readonly loader: TrustpilotWidgetLoaderService) { }

  ngAfterViewInit(): void {
    this.loader.load()
      .then(() => {
        if (!window.Trustpilot) {
          console.error('Trustpilot widget script loaded but window.Trustpilot is not available');
          return;
        }
        window.Trustpilot.loadFromElement(this.trustbox().nativeElement, true);
      })
      .catch((err) => {
        console.error('Failed to load Trustpilot widget script', err);
      });
  }
}
